import { loadView } from '@/router'

export default [
  {
    path: 'invoices',
    name: 'billing-invoices',
    component: loadView('Application/Billing/Invoices'),
    showInAlfred: true,
    alfredTitle: 'Billing - Invoices'
  }
]
